export default __webpack_public_path__ + "static/media/lottery_pc.ca2036b9.jpg";